document.addEventListener("DOMContentLoaded", function() {
    const sizeGallerySection = document.querySelector('.size-gallery-section');
    const filterButtons = sizeGallerySection.querySelectorAll('.filter-btn');
    const galleryItems = Array.from(sizeGallerySection.querySelectorAll('.gallery-item'));
    const loadMoreLink = sizeGallerySection.querySelector('.load-more-link');
    const itemsToShowMobile = 4;
    const itemsToShowDesktop = 5;
    let currentItems = 0;
    let currentFilter = 'all';
    let currentIndex = 0;

    function initGalleryItems() {
        galleryItems.forEach((item, index) => {
            const img = document.createElement('img');
            img.src = item.dataset.src;
            img.alt = `${item.dataset.category} image`;
            item.appendChild(img);
            item.style.display = 'none'; // Initially hide all items
            item.addEventListener('click', () => openModal(index));
        });
    }

    function getItemsToShow() {
        return window.innerWidth < 768 ? itemsToShowMobile : itemsToShowDesktop;
    }

    function showItems(reset = false) {
        if (reset) {
            currentItems = 0;
            loadMoreLink.style.display = 'block';
        }

        const filteredItems = currentFilter === 'all'
            ? galleryItems
            : galleryItems.filter(item => item.classList.contains(currentFilter));

        const itemsToShow = getItemsToShow();
        filteredItems.slice(currentItems, currentItems + itemsToShow).forEach(item => {
            item.style.display = 'block';
        });
        currentItems += itemsToShow;
        if (currentItems >= filteredItems.length) {
            loadMoreLink.style.display = 'none';
        }
    }

    function handleFilterClick(event) {
        filterButtons.forEach(btn => btn.classList.remove('active'));
        event.currentTarget.classList.add('active');

        currentFilter = event.currentTarget.getAttribute('data-filter');
        galleryItems.forEach(item => item.style.display = 'none');
        showItems(true); // Reset the items shown
    }

    function openModal(index) {
        const filteredItems = galleryItems.filter(item => item.style.display === 'block');
        currentIndex = filteredItems.findIndex(item => galleryItems.indexOf(item) === index);

        if (currentIndex === -1) return;

        const imgSrc = filteredItems[currentIndex].dataset.src;
        let modal = sizeGallerySection.querySelector('.modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.classList.add('modal', 'active');
            modal.innerHTML = `
                <div class="modal-content">
                    <span class="close">&times;</span>
                    <img src="${imgSrc}" alt="Modal Image" class="modal-image">
                    <button class="prev">&lt;</button><button class="next">&gt;</button>
                </div>
            `;
            sizeGallerySection.appendChild(modal);
        } else {
            modal.querySelector('.modal-image').src = imgSrc;
            modal.classList.add('active');
        }

        const closeBtn = modal.querySelector('.close');
        const prevBtn = modal.querySelector('.prev');
        const nextBtn = modal.querySelector('.next');

        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeModal();
            }
        });

        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => navigateModal(-1));
            nextBtn.addEventListener('click', () => navigateModal(1));
        }
    }

    function closeModal() {
        const modal = sizeGallerySection.querySelector('.modal');
        if (modal) {
            modal.classList.remove('active');
        }
    }

    function navigateModal(direction) {
        const filteredItems = galleryItems.filter(item => item.style.display === 'block');
        currentIndex = (currentIndex + direction + filteredItems.length) % filteredItems.length;
        const imgSrc = filteredItems[currentIndex].dataset.src;
        const modalImage = sizeGallerySection.querySelector('.modal-image');
        modalImage.src = imgSrc;
    }

    // Initialize gallery items and show initial set
    initGalleryItems();
    showItems();

    loadMoreLink.addEventListener('click', (e) => {
        e.preventDefault();
        showItems();
    });

    filterButtons.forEach(button => {
        button.addEventListener('click', handleFilterClick);
    });
});
